import { BigDecimal } from "@solomon-labs/bigdecimal";

import { useReportingToken } from "./useJachinReporting";
interface UseReportingLiveApyResult {
    apy: number | null;
    formattedApy: string;
    isLoading: boolean;
}

/** Shared current APY for the home page and Stats. Read from token-stats, the
 *  envelope the supply figures already load. A `stale` envelope still carries
 *  the last APY the source reported, which beats rendering no rate at all. */
export function useReportingLiveApy(): UseReportingLiveApyResult {
    const query = useReportingToken();
    const sourceApy = !query.isError && query.data?.status !== "unavailable" ? query.data?.data?.sourceApyPct : null;
    return {
        apy: sourceApy !== null && sourceApy !== undefined ? new BigDecimal(sourceApy).toNumber() : null,
        formattedApy:
            sourceApy !== null && sourceApy !== undefined ? `${new BigDecimal(sourceApy).round(2).toFixed(2)}%` : "—",
        isLoading: query.isLoading
    };
}
